<template>
  <div v-if="doc" class="type-body-sm pt-32 md:pt-36">
    <DefaultGrid
      class="space-y-10 md:space-y-14 lg:space-y-0 lg:pt-28 xl:pt-32"
    >
      <header
        class="col-span-full pt-10 md:pt-14 lg:col-span-4 lg:pt-0 xl:col-span-6"
      >
        <h1 class="type-heading-3" v-text="doc.title" />
        <p v-if="doc.intro" v-text="doc.intro"></p>
      </header>
      <main class="col-span-full lg:col-span-8 xl:col-span-6">
        <div class="rich-text">
          <PayloadRichText :content="doc.content" />
          <p>
            <em>Dated: {{ $dayjs(doc.updatedAt).format('DD/MM/YYYY') }}</em>
          </p>
        </div>
      </main>
    </DefaultGrid>
    <PageFooter />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const doc = await usePayloadStaticPage(route.params.slug as string)

if (!doc.value) {
  throw createError({
    statusCode: 404,
    message: 'Page not found.',
  })
}
</script>

<style scoped lang="postcss">
.rich-text :deep(a) {
  @apply font-medium;
}
</style>
